module.exports = __webpack_public_path__ + "3332c4add492a73790f9b02b3f8ab08f.pdf";